import React from "react";
import { FiEdit } from "react-icons/fi";
import { IoDocumentLockOutline } from "react-icons/io5";
import { RiFileInfoLine } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import { formatINR, formatINRShort } from "../../../../utils/formatINR";

const VillaUnitTable = ({ units = [], onEdit, onAdd, totalUnitRow = 0 }) => {
  console.log("VillaUnitTable", units);

  const tableRows = Array.from({ length: totalUnitRow }, (_, index) => {
    const unit = units[index] || null;
    return {
      id: unit?.id || `placeholder-${index}`,
      unitNo: unit?.unitNo || null,
      carpetArea: unit?.carpetArea || null,
      buildUpArea: unit?.buildUpArea || null,
      floors: unit?.floors || null,
      baseRate: unit?.baseRate || null,
      saleableArea: unit?.saleableArea || null,
      allInclusiveCharges: unit?.allInclusiveCharges || null,
      basePrice: unit?.basePrice || null,
      notes: unit?.notes || null,
      totalBhk: unit?.totalBhk || null,

      lift: unit?.lift || null,
      bathrooms: unit?.bathrooms ||null,
      villaViewType: unit?.villaViewType || null,
      coveredParking: unit?.coveredParking ||null,
      swimmingPool: unit?.swimmingPool ||null,
      parking: unit?.parking || null,
     
      furnished: unit?.furnished || null,
      furnishedCharge : unit?.furnishedCharge || null,
      electricityCharge : unit?.electricityCharge || null,
      preferredLocationCharge : unit?.preferredLocationCharge || null,
      roadFacingSide: unit?.roadFacingSide || { id: "", name: null },
      terraceArea: unit?.terraceArea || null,

      guidelineSqftPrice: unit?.guidelineSqftPrice || null,
      registrationCharge: unit?.registrationCharge || null,
      totalPrice: unit?.totalPrice || null,
      unitStatus: unit?.unitStatus || { id: "", name: null },
      order: unit?.order || index + 1,
      isPlaceholder: !unit || unit.isArchived,
      statusName : unit?.unitStatus?.name || null,
    };
  });

  const getStatusStyles = (status) => {
    switch (status) {
      case "Available":
        return "border-[#399E79] border bg-green-50 text-green-800";
      case "Agreement":
        return "border-[#FFDF94] border bg-yellow-50 text-yellow-800";
      case "Booked":
        return "border-[#EE6C4D] border bg-red-50 text-red-800";
      default:
        return "border-[#2280FF] border bg-blue-50 text-blue-800";
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-100 text-base text-center rounded-md">
              <th className="px-4 py-3 text-gray-700 font-medium">Unit No.</th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Saleable Area
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Build-Up Area
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">Floors</th>
              <th className="px-4 py-3 text-gray-700 font-medium">BHK</th>

              <th className="px-4 py-3 text-gray-700 font-medium">Base Rate</th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Base Price
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">Status</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {tableRows.length > 0 ? (
              tableRows.map((row) => {
                const basePrice = row.saleableArea && row.baseRate ? row.saleableArea * row.baseRate : row.basePrice;

                return (
                <tr
                  key={row.id}
                  className="border-b text-center border-gray-200 hover:bg-gray-50"
                >
                  <td className="px-4 text-sm py-4">{row.unitNo || "N/A"}</td>
                  <td className="px-4 py-4 text-sm">{row.saleableArea || "N/A"}</td>
                  <td className="px-4 py-4 text-sm">{row.buildUpArea || "N/A"}</td>

                  <td className="px-4 py-4 text-sm">{row.floors || "N/A"}</td>
                  <td className="px-4 py-4 text-sm">{row.totalBhk || "N/A"}</td>
                  <td className="px-4 py-4 text-sm cursor-pointer" title={row.baseRate ? formatINR(row.baseRate) : "0"}>
                    {row.baseRate ? formatINRShort(row.baseRate) : "N/A"}
                  </td>

                  <td title={basePrice ? formatINR(basePrice) : "0"} className="px-4 py-4 text-sm font-medium cursor-pointer">
                    {basePrice ? formatINRShort(basePrice) : "N/A"}
                  </td>

                  <td className="px-4 py-4">
                    <span
                      className={`px-3 py-1 text-xs rounded-full ${getStatusStyles(
                        row.unitStatus.name
                      )}`}
                    >
                      {row.unitStatus?.name || "Available"}
                    </span>
                  </td>
                  {row.unitStatus?.name === "Available" ||
                  !row?.unitStatus?.name ? (
                    <td className="px-4 py-4">
                      {row.isPlaceholder ? (
                        <button
                          onClick={() =>
                            onAdd({
                              order: row.order,
                              unitNo: "",
                              carpetArea: null,
                              buildUpArea: null,
                              terraceArea: null,
                              guidelineSqftPrice: null,
                              floors: null,
                              totalBhk: null,
                              bathrooms: null,
                              roadFacingSide: "",

                              furnished: "",
                              parking: "",
                              coveredParking: "",
                              lift: "",
                              allInclusiveCharges: null,
                              swimmingPool: "",
                              villaViewType: "",
                              unitStatusId: "",
                            })
                          }
                          className="p-1 px-2 bg-customGreen text-white rounded-md transition-colors flex items-center justify-center"
                          aria-label="Add unit"
                        >
                          <span className="text-sm">Add</span>
                        </button>
                      ) : (
                        <button
                          onClick={() => onEdit(row)}
                          className="p-2 text-customGreen hover:bg-blue-50 rounded-md transition-colors"
                          aria-label="Edit unit"
                        >
                          <FiEdit size={20} />
                        </button>
                      )}
                    </td>
                  ) : (
                    <td  onClick={() => onEdit(row)} className="text-center  hover:text-customGreen flex items-center justify-center   text-2xl mt-5 cursor-pointer">
                      <FaRegEye />
                    </td>
                  )}
                </tr>
              );})
            ) : (
              <tr className="text-center ">
                <td colSpan={10} className="py-8 text-gray-500">
                  No units found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            {onAdd && (
              <tr>
                <td colSpan={10} className="px-4 py-4 text-center">
                  <button
                    onClick={() =>
                      onAdd({
                        order: tableRows.length + 1,
                        unitNo: "",
                        carpetArea: null,
                        buildUpArea: null,
                        terraceArea: null,
                        guidelineSqftPrice: null,
                        floors: null,
                        totalBhk: null,
                        floorsBhk: [{ floor: 1, bhk: null }],
                        bathrooms: null,
                        roadFacingSide: "",
                        totalPrice: null,
                        furnished: "",
                        parking: "",
                        coveredParking: "",
                        lift: "",
                        swimmingPool: "",
                        villaViewType: "",
                        unitStatusId: "",
                      })
                    }
                    className="px-4 py-2 bg-customGreen text-white rounded-md transition-colors flex items-center mx-auto"
                  >
                    Add New Unit
                  </button>
                </td>
              </tr>
            )}
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default VillaUnitTable;
